/* eslint-disable @typescript-eslint/camelcase */

import urlcat from 'urlcat';

import { API_URL } from '@/config/xsolla';

function buildURL(endpoint: string, params = {}): string {
  return urlcat(API_URL as string, endpoint, params);
}

enum Endpoint {
  TOKEN = '/oauth2/token',
  LOGOUT = '/oauth2/logout',
  USER_INFO = '/users/me',
}

export default {
  token_endpoint: buildURL(Endpoint.TOKEN),
  revocation_endpoint: buildURL(Endpoint.LOGOUT, { sessions: 'all' }),
  end_session_endpoint: buildURL(Endpoint.LOGOUT, { sessions: 'sso' }),
  userinfo_endpoint: buildURL(Endpoint.USER_INFO),
  authorization_endpoint: '',
};
